import { API_URL, setHeader } from 'api';
import axios from 'axios';

const URL = `${API_URL}/questionnaire`;

export const fetchArchiveQuestions = p => {
  const params = {
    start: p.start,
    limit: p.limit,
  };
  const req = setHeader(axios);
  return req.get(`${URL}/archived`, { params });
};
